var map = {
	"./slide_billma.svg": "./src/modules/Claim/views/compensationType/assets/slide_billma.svg",
	"./slide_gag.svg": "./src/modules/Claim/views/compensationType/assets/slide_gag.svg",
	"./slide_ren.svg": "./src/modules/Claim/views/compensationType/assets/slide_ren.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules/Claim/views/compensationType/assets sync recursive ^\\.\\/.*\\.svg$";